<template>
<!-- eslint-disable max-len -->
<div
  v-if="challengeLocked"
  class="lock-message"
>
  <div v-html="unlockMessage"></div>
</div>
<narrative-player
  v-else
  :narratives="narratives"
  :on-complete="onComplete"
>
</narrative-player>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { getGroupUnlockDate, isGroupLocked } from '@/utils/challenge-locks';

import NarrativePlayer from '../narrative/NarrativePlayer';

export default {
  components: {
    NarrativePlayer
  },
  computed: {
    ...mapGetters([
      'group',
      'challenge',
      'lastStateBeforeChallengeIntro',
      'entryState',
      'activeClass',
      'currentChallengeIndex',
    ]),
    narratives() {
      return this.challenge && this.challenge.introNarratives || [];
    },
    currentChallengeLock() {
      if (this.activeClass == null || this.activeClass.challengeLocks == null
        || this.activeClass.challengeLocks.length === 0) {
        return null;
      }
      const l = this.activeClass.challengeLocks.find(
        el => el.challengeIndex === this.currentChallengeIndex && !(el.outro)
      );
      if (l) {
        l.unlockDate = new Date(l.unlockDate);
      }
      return l;
    },
    challengeLocked() {
      if (this.currentChallengeLock == null) {
        return false;
      }
      return isGroupLocked(this.group, this.currentChallengeLock);
    },
    timeStringOptions() {
      return {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      };
    },
    challengeUnlockTimeString() {
      if (this.currentChallengeLock == null) {
        return (new Date(Date.now())).toLocaleString(undefined, this.timeStringOptions);
      }
      return getGroupUnlockDate(this.group, this.currentChallengeLock).toLocaleString(undefined, this.timeStringOptions);
    },
    unlockMessage() {
      const lockMessage =
        (this.currentChallengeLock && this.currentChallengeLock.lockMessageOverride)
          ? this.currentChallengeLock.lockMessageOverride
          : ((this.activeClass && this.activeClass.lockMessage)
            ? this.activeClass.lockMessage
            : 'You cannot progress further at this time. To continue, refresh after: {time}');
      return lockMessage.replace('{time}', this.challengeUnlockTimeString);
    },
  },
  methods: {
    ...mapActions([
      'getActiveEnvironment',
      'resetLastStateBeforeChallengeIntro',
      'setCurrentChallengeIntroViewed'
    ]),
    async onComplete() {
      await this.setCurrentChallengeIntroViewed();
      const { lastStateBeforeChallengeIntro } = this;
      this.resetLastStateBeforeChallengeIntro();
      this.$router.nextGameState({
        route: lastStateBeforeChallengeIntro || this.entryState
      });
    }
  },
  async mounted() {
    await this.getActiveEnvironment();
  }
};
</script>

<style lang="scss" scoped>
.lock-message {
  height: 900px;
  width: 100%;
  background-color: var(--primaryColor);
  color: white;
  font-size: 150%;
  text-shadow:
    black 0 0 12px,
    black 0 0 15px,
    black 0 0 18px,
    black 0 0 21px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/game/pages/ChallengeIntro.vue